import type { FieldPolicy, TypePolicies } from '@apollo/client';

// Since we fetch the list of documents on page load,
// we may already have the data about an InteractionDocument in the cache.
// By default, Apollo doesn't know that the data in Listing.documents
// is associated with the data in Listing.document.
// These read functions allow us to connect those dots.
// See https://www.apollographql.com/docs/react/caching/advanced-topics/#cache-redirects
const interactionDocumentReadPolicy: FieldPolicy['read'] = (
  _,
  { args, toReference },
) => {
  return toReference({
    __typename: 'InteractionDocument',
    id: args?.id,
  });
};

export const Listing: TypePolicies['Listing'] = {
  fields: {
    document: {
      read: interactionDocumentReadPolicy,
    },
    property: {
      merge: true,
    },
  },
};
export const Offer: TypePolicies['Offer'] = {
  fields: {
    document: {
      read: interactionDocumentReadPolicy,
    },
    property: {
      merge: true,
    },
  },
};
export const Interaction: TypePolicies['Interaction'] = {
  fields: {
    document: {
      read: interactionDocumentReadPolicy,
    },
    property: {
      merge: true,
    },
  },
};
